export const Empty = () => {
    return (
        <div className="flex flex-col items-center py-20">
            <img className="w-4/12" src="/no-data.svg" />
            <h3 className="text-xl font-semibold">No data to display</h3>
        </div>
    );
};
